<template lang="pug">
  b-autocomplete(v-model="label" ref="labelInput" maxlength="48" append-to-body :data="filteredLabels" open-on-focus clearable :loading="loading" :placeholder="$t('sale.label_placeholder')" @input="updateLabel")
</template>
<script>
import SalesApi from '@/api/sales'

export default {
  name: 'SaleLabelAutocomplete',
  props: {
    value: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      labels: [],
      label: '',
      loading: false
    }
  },
  computed: {
    filteredLabels() {
      return this.labels.filter(option => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.label.toLowerCase()) >= 0
        )
      })
    }
  },
  watch: {
    value(newVal) {
      this.label = newVal
    }
  },
  created() {
    if (this.value) {
      this.label = this.value
    }
    this.fetchLabels()
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.labelInput.focus()
    })
  },
  methods: {
    async fetchLabels() {
      this.loading = true
      this.labels = await SalesApi.listLabels()
      this.loading = false
    },
    updateLabel() {
      this.$emit('input', this.label)
    }
  }
}
</script>
